<template>
    <div>
        <div>
            <!-- TODO: Loading if !loaded -->
            <kendo-dropdownlist
                :ref="'nomDropdown' + _uid"
                :id="'nomDropdown' + _uid"
                v-if="loaded"
                v-model="selectedId"
                :data-source="items"
                :data-text-field="isEnVersion ? 'textEn' : 'text'"
                :data-value-field="'id'"
                :filter="filterPattern"
                :optionLabel="$t('choose')"
                @change="inputChanged"
                :name="'dropdown' + _uid"
                :data-vv-as="fieldName"
                :clear-button="true"
                v-validate="required ? 'required' : ''"
                style="width: 100%;"
                :disabled="disabled"
                :height="height"
                :no-data-template="nomDropdownSettings.showNoDataTemplate ? noDataTemplate : ''"
                :footer-template="nomDropdownSettings.showFooterTemplate ? footerTemplate : ''"
            ></kendo-dropdownlist>
        </div>
        <span
            class="text-danger col-12"
            v-if="errors.has('dropdown' + _uid)"
        >{{ errors.first('dropdown' + _uid) }}</span>

        <vs-prompt
            :title="$t('registers.nomenclatures.add')"
            :active.sync="showNomCreate"
            :buttons-hidden="true"
            @cancel="cancelPrompt"
            @close="cancelPrompt"
            color="primary"
        >
            <div>
                <NomenclatureEditCard
                    :nomSort="nomParentSort"
                    :nomName="nomParentType"
                    :create="true"
                    :key="nomParentSort"
                    @nomEditCancel="nomEditCancel"
                    @nomEditSave="nomEditSave"
                ></NomenclatureEditCard>
                <div class="clearfix"></div>
            </div>
        </vs-prompt>

        <DropdownSettings v-if="loaded"
            :filterPattern.sync="filterPattern"
            :show.sync="showSettings">
        </DropdownSettings>
    </div>
</template>

<script>
import Vue from "vue";
import NodataTemplate from "../../components/grid/NomenclatureDropdownNodataTemplate";
import FooterTemplate from "../../components/grid/NomenclatureDropdownFooterTemplate";
import DropdownSettings from "../../components/common/DropdownSettings";
import NomenclatureEditCard from "./NomenclatureEditCard";
import { mapGetters } from "vuex";

// workaround for kendo dropdownlist to work in bootstrap modal
(function ($, kendo) {
    var _init = kendo.ui.Popup.fn.init;

    var Popup = kendo.ui.Popup.extend({
        init: function (element, options) {
            // Only set appendTo if nothing usable was manually set in the options.
            // An appendTo that resolves to no element is treated as "not set" - иначе Kendo
            // пада към document.body, попъпът излиза извън модала и Bootstrap focus trap-ът
            // краде фокуса от полето за търсене в него.
            if (options.appendTo === undefined || $(options.appendTo).length === 0) {
                // Find the nearest parent bootstrap modal, if any.
                var parentModal = $(options.anchor).closest(".modal");

                // Found one!
                if (parentModal.length > 0) {
                    options.appendTo = parentModal[0];
                }
            }

            // Call the base constructor.
            _init.call(this, element, options);
        },
    });

    kendo.ui.plugin(Popup);
})(window.kendo.jQuery, window.kendo);

export default {
    inject: ["$validator"],
    props: {
        value: [Number, String],
        parentSort: {
            type: Number,
            default: 0,
        },
        loadByParentSort: {
            type: Boolean,
            default: false,
        },
        type: String,
        isCity: {
            type: Boolean,
            default: false,
        },
        // Името което показва vee-validate
        fieldName: {
            type: String,
            required: true,
        },
        required: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        height: {
            type: Number,
            default: 400, // 200 - Default value for Kendo DropdownList
        },
        // Приемат се за съвместимост с извикващите компоненти, но не се подават на
        // kendo-dropdownlist - разположението на попъпа се поема от глобалния Popup patch
        // по-горе, който го закача в най-близкия .modal.
        bindPopup: {
            type: Boolean,
            default: false,
        },
        popupContainerId: {
            type: String,
            default: "",
        }
    },
    components: {
        NomenclatureEditCard,
        DropdownSettings,
    },
    data() {
        return {
            selectedId: this.value,
            loaded: false,
            items: [],
            showNomCreate: false,
            nomParentSort: 0,
            nomParentType: "",
            showSettings: false,
            filterPattern: '',
        };
    },
    methods: {
        loadItems() {
            let url = "";
            if (this.loadByParentSort) {
                url = `/api/search/GetNomenclatureItemsByParentSort?sort=${this.parentSort}&selected=${this.value}`;
            } else {
                url = `/api/search/GetNomenclatureItems?type=${this.type}&isCity=${this.isCity}&selected=${this.value}`;
            }

            if (url) {
                this.$http.get(url).then((result) => {
                    this.items = result.data;
                    this.selectedId = this.value;
                    this.$emit("change", this.value);
                    this.loaded = true;
                });
            }
        },
        inputChanged(event) {
            this.$emit("input", event.sender.value());
            this.$emit("change", event.sender.value());

            const dropdown = this.$refs["nomDropdown" + this._uid].kendoWidget();
            if (dropdown) {
                this.$emit("textChange", dropdown.text());
            }
        },
        templateBtns(e) {
            return [
                this.hasCreateRights
                    ? {
                          name: "addNomenclature",
                          text: this.$t("buttons.add.btnText"),
                          tooltip: this.$t("buttons.add.btnText"),
                          class: "btn btn-secondary",
                          icon: "far fa-plus-square",
                          show: true,
                          clickHandler: this.addNomenclature,
                      }
                    : {},
            ];
        },
        noDataTemplate: function (e) {
            return {
                template: Vue.component(NodataTemplate.name, NodataTemplate),
                templateArgs: {
                    ...e,
                    noDataFound: this.$t("dropdownList.noDataFound"),
                    createQuestion: this.$t("dropdownList.createQuestion"),
                    btns: this.templateBtns(e),
                },
            };
        },
        footerTemplate: function (e) {
            return {
                template: Vue.component(FooterTemplate.name, FooterTemplate),
                templateArgs: {
                    ...e,
                    btns: [...this.templateBtns(e),
                        {
                            name: "nomenclatureDropdownSettings",
                            text: this.$t("buttons.settings.btnText"),
                            tooltip: this.$t("buttons.settings.btnText"),
                            class: "btn btn-secondary",
                            icon: "fas fa-cog",
                            show: this.nomDropdownSettings.showSettings,
                            clickHandler: () => {
                                this.showSettings = true;
                            },
                        }
                    ],
                },
            };
        },
        addNomenclature(args) {
            if (!this.hasCreateRights) {
                // Todo: show message
                return;
            }

            this.showNewNomenclatureModal(args);
        },
        showNewNomenclatureModal() {
            this.nomParentSort = this.parentSort;
            this.nomParentType = this.type;
            this.showNomCreate = true;
        },
        clearFilterAndText() {
            const dropdown = this.$refs["nomDropdown" + this._uid].kendoWidget();
            if (dropdown) {
                dropdown.dataSource.filter({});
                if (dropdown.filterInput && dropdown.filterInput.length > 0) {
                    dropdown.filterInput[0].value = "";
                }
            }
        },
        nomEditCancel() {
            this.clearFilterAndText();
            this.nomParentSort = 0;
            this.nomParentType = "";
            this.showNomCreate = false;
        },
        nomEditSave() {
            this.clearFilterAndText();
            this.nomParentSort = 0;
            this.nomParentType = "";
            this.showNomCreate = false;
            this.loadItems();
        },
        cancelPrompt() {
            this.clearFilterAndText();
            this.nomParentSort = 0;
            this.nomParentType = "";
            this.showNomCreate = false;
        },
    },
    computed: {
        ...mapGetters(['isEnVersion', 'claims', 'nomDropdownSettings']),
        hasCreateRights() {
            return this.claims.nomenclature.create;
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal, oldVal) {
                this.selectedId = newVal;
            },
        },
        selectedId: function (newVal, old) {
            this.$emit("input", newVal);
        },
        type: {
            immediate: true,
            handler(newVal, oldVal) {
                this.type = newVal;
                this.loadItems();
            },
        },
    },
    mounted() {
        this.filterPattern = this.nomDropdownSettings.defaultFilterPattern;
        this.loadItems();
    },
};
</script>
